import React, { useReducer, ReactNode } from "react";
import { mainReducer } from "./reducer";
import { MainState, MainContextType } from "./types";

const defaultState: MainState = {
  loading: false,
  snackbar: false,
  breadcrumb: false,
  modal: false,
  statusEnum: [],
  projectCreateStepEnum: [],
  paymentTermEnum: [],
  compnayTypeEnum: [],
};

export const MainContext = React.createContext<MainContextType>({
  ...defaultState,
  setLoading: () => {},
  setSnackbar: () => {},
  setBreadcrumb: () => {},
  setStatusEnum: () => {},
  setProjectCreateStepEnum: () => {},
  setPaymentTermEnum: () => {},
  setCompanyTypeEnum: () => {},
  setModal: () => {},
});

export const GlobalProvider = ({ children }: { children: ReactNode }) => {
  const [state, dispatch] = useReducer(mainReducer, defaultState);
  const mainState = state as MainState;

  const setLoading = (payload: boolean) => {
    dispatch({ type: "SET_LOADING", payload });
  };

  const setSnackbar = (payload: MainState['snackbar']) => {
    dispatch({ type: "SET_SNACK", payload });
  };

  const setBreadcrumb = (payload: MainState['breadcrumb']) => {
    dispatch({ type: "SET_BREADCRUMB", payload });
  };

  const setProjectCreateStepEnum = (payload: MainState['projectCreateStepEnum']) => {
    dispatch({ type: "SET_PROJECT_CREATE_STEP_ENUM", payload });
  };

  const setStatusEnum = (payload: MainState['statusEnum']) => {
    dispatch({ type: "SET_STATUS_ENUM", payload });
  };

  const setPaymentTermEnum = (payload: MainState['paymentTermEnum']) => {
    dispatch({ type: "SET_PAYMENT_TERM_ENUM", payload });
  };

  const setCompanyTypeEnum = (payload: MainState['compnayTypeEnum']) => {
    dispatch({ type: "SET_COMPANY_TYPE_ENUM", payload });
  };

  const setModal = (payload: MainState['modal']) => {
    dispatch({ type: "SET_MODAL", payload });
  };

  const value: MainContextType = {
    loading: mainState.loading,
    snackbar: mainState.snackbar,
    breadcrumb: mainState.breadcrumb,
    statusEnum: mainState.statusEnum,
    projectCreateStepEnum: mainState.projectCreateStepEnum,
    paymentTermEnum: mainState.paymentTermEnum,
    compnayTypeEnum: mainState.compnayTypeEnum,
    modal: mainState.modal,

    setLoading,
    setSnackbar,
    setBreadcrumb,
    setStatusEnum,
    setProjectCreateStepEnum,
    setPaymentTermEnum,
    setCompanyTypeEnum,
    setModal,
  };

  return <MainContext.Provider  value={value}>{children}</MainContext.Provider>;
};
